import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { NotificationService } from 'src/app/services/notification.service';
import { finalize } from 'rxjs';
import { DashboardService } from '../../dashboard.service';
import { DocumentData, PreluareNrRegistru } from '../../document.interface';
import { Generic, GenericCompartimentSearch } from 'src/app/interfaces/generic.interface';
import { CommonService } from 'src/app/services/common.service';
import { Observable, Subject, of } from 'rxjs';
import {
    debounceTime,
    distinctUntilChanged,
    switchMap,
    catchError,
    tap,
    map,
    takeUntil,
} from 'rxjs/operators';

@Component({
    selector: 'app-preluare-nr-registru',
    templateUrl: './preluare-nr-registru.component.html',
    styleUrls: ['./preluare-nr-registru.component.scss']
})
export class PreluareNrRegistruComponent {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    token!: string;
    isLoading: boolean = false;
    helper = helper;

    defaultParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    registreActiveSwitch: Generic[] = [];

    new_number_optionsSameSerieAsParent: { name: string; id: number }[] = [
        {
            id: 0,
            name: '-- Alegeți --'
        },
        {
            id: 1,
            name: 'Emitere cu număr existent: ' + this.data.docData.info.parent_reg_number
        },
        {
            id: 2,
            name: 'Număr nou/la rând'
        },
        {
            id: 3,
            name: "Alt numar anterior. Necesita completare"
        }
    ];

    new_number_options: { name: string; id: number }[] = [
        {
            id: 0,
            name: '-- Alegeți --'
        },
        {
            id: 2,
            name: 'Număr nou/la rând'
        },
        {
            id: 3,
            name: "Alt numar anterior. Necesita completare"
        }
    ]

    form: FormGroup = new FormGroup({
        id_serie: new FormControl(-1, Validators.compose([
            Validators.required, Validators.min(0)
        ])),
        new_number: new FormControl(-1, Validators.compose([
            Validators.required, Validators.min(0)
        ])),
        registratura_number: new FormControl('')
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<PreluareNrRegistruComponent>,
        private dashboardService: DashboardService,
        private notificationService: NotificationService,
        private commonService: CommonService,
    ) {

        this.loadActiveSwitch()

        console.log(this.data.docData.info.parent_reg_number, 'is it here?')
    }

    // În componenta ta
    get currentNumberOptions(): { name: string; id: number }[] {
        if (this.data.docData.info.parent_serie_id === this.form.get('id_serie')?.value) {
            return this.new_number_optionsSameSerieAsParent;
        }
        return this.new_number_options;
    }

    onRegistraturaTypeSelected(registraturaType: number) {
        const registratura_number = this.form.get('registratura_number') as FormControl;

        if (registraturaType === 2) {
            registratura_number.setValidators([Validators.required]);
            registratura_number.markAsUntouched();
        } else {
            registratura_number.patchValue('');
            registratura_number.clearValidators();
            registratura_number.setErrors(null);
            registratura_number.markAsUntouched();
        }

        this.form.updateValueAndValidity();
    }


    loadActiveSwitch() {
        this.isLoading = true;
        this.commonService
            .getActiveSwitch()
            .pipe(
                map((resp: Generic[]) => [this.defaultParameter, ...resp]),
                finalize(() => this.isLoading = false)
            )
            .subscribe({
                next: (results) => {
                    this.registreActiveSwitch = results;
                },
                error: (error) => {
                    console.error('Error loading directii', error);
                },
            });
    }

    closeDialog(): void {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const { id_serie, new_number, registratura_number } = this.form.value as PreluareNrRegistru;

        const formData = {
            id_serie,
            new_number,
            registratura_number
        };

        this.dashboardService
            .registerNumberActivityServiciu(this.data.activityId, formData)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

}
